import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=19e106be&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=js&"
export * from "./cooperation.vue?vue&type=script&lang=js&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=19e106be&prod&lang=scss&scoped=true&"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=19e106be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e106be",
  null
  
)

export default component.exports